import ready, {HTML} from './utils';
import initAccordion from './components/accordion';
import initMobileNav from './components/mobileNav';
import initSlickCarousel from './components/slickCarousel';
import initBlockMovement from './components/blockMovement';
import initMapbox from './components/mapbox';
import initOpenClose from './components/openClose';
import initImagesIndent from './components/imagesIndent';
import initFancybox from './components/fancybox';
import initCustomForms from './components/customForms';
import initContactForm from './components/contactForm';
import initAnchors from './components/anchorLinks';
import initUSAMap from './components/USAMap';
import initVideo from './components/video';
import initAutocomplete from './components/autocomplete';
import initCounterUp from './components/counterUp';
import initPopups from './components/popup';
import initAjaxFIltering from './components/ajaxFiltering';
import initAddIndentHeaderClass from './components/classOnHeader';
import initBannerActions from './components/banner';
import initHeadroom from './components/headroom';

ready(() => {
	HTML.classList.add('is-loaded');

	initMobileNav();
	initAccordion();
	initSlickCarousel();
	initBlockMovement();
	initMapbox();
	initOpenClose();
	initCustomForms();
	initContactForm();
	initAnchors();
	initUSAMap();
	initVideo();
	initAutocomplete();
	initCounterUp();
	initPopups();
	initAjaxFIltering();
	initAddIndentHeaderClass();
	initBannerActions();
	initHeadroom();
});

jQuery(window).on('load', function() {
	initImagesIndent();
	initFancybox();
});